import Modal from 'styled-react-modal'
import colors from '@settings/styleSettings'

export const ContainerModal = Modal.styled`
  background-color: ${colors.titleStrongWhite};
  padding: 20px;
  border-radius: 12px;
  height: auto;
  width: auto;
`
